
import Vue from 'vue'

const locales = {keys(){return []}}
global['____058504A____'] = true;
delete global['____058504A____'];
global.__uniConfig = {"tabBar":{"color":"#000000","selectedColor":"#d2951a","backgroundColor":"#ffffff","list":[{"pagePath":"pages/home/home","text":"首页","iconPath":"static/img/tabbar-main.png","selectedIconPath":"static/img/tabbar-main-checked-y.png","redDot":false,"badge":""},{"pagePath":"pages/main/showSearch","text":"演出","iconPath":"static/img/tabbar-show.png","selectedIconPath":"static/img/tabbar-show-checked-y.png","redDot":false,"badge":""},{"pagePath":"pages/ticketWallet/ticketWallet","text":"票夹","iconPath":"static/img/tabbar-ticket.png","selectedIconPath":"static/img/tabbar-ticket-checked-y.png","redDot":false,"badge":""},{"pagePath":"pages/my/my","text":"我的","iconPath":"static/img/tabbar-my.png","selectedIconPath":"static/img/tabbar-my-checked-y.png","redDot":false,"badge":""}],"borderStyle":"black"},"globalStyle":{"navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff","backgroundColor":"#fbf9fe"},"shareTimeline":true,"condition":{"current":0,"list":[{"name":"主进程","path":"pages/index/index","query":"type=2&showId=9hls34dw61a9&id=98rpw81ucd8h"},{"name":"场馆详情","path":"pagespacka/venueManage/venueDetail","query":"id=d11sb9fqemma"},{"name":"余额","path":"pages/showDetail/showDetail","query":"showId=1774670770593181698"},{"name":"卡包","path":"pages/valueCard/valueCard","query":""}]}};
global.__uniConfig.compilerVersion = '3.4.18';
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__058504A';
global.__uniConfig.appName = '';
global.__uniConfig.appVersion = '1.0.0';
global.__uniConfig.appVersionCode = '100';
global.__uniConfig.router = {"mode":"history","base":"/"};
global.__uniConfig.publicPath = "/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {"maps":{"qqmap":{"key":"S6EBZ-C3I3Q-RBH57-2UZFC-2RON2-62FQS"}}};
global.__uniConfig.qqMapKey = "S6EBZ-C3I3Q-RBH57-2UZFC-2RON2-62FQS";
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pages/index/index.vue')), 'pages-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-home-home', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pages/home/home.vue')), 'pages-home-home'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-news-news', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pages/news/news.vue')), 'pages-news-news'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-login', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pages/login/login.vue')), 'pages-login-login'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-reg', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pages/login/reg.vue')), 'pages-login-reg'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-pwd', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pages/login/pwd.vue')), 'pages-login-pwd'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-ticketWallet-ticketWallet', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pages/ticketWallet/ticketWallet.vue')), 'pages-ticketWallet-ticketWallet'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-my', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pages/my/my.vue')), 'pages-my-my'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-showDetail-showDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pages/showDetail/showDetail.vue')), 'pages-showDetail-showDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-main-couponList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pages/main/couponList.vue')), 'pages-main-couponList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-activity', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pages/activity/activity.vue')), 'pages-activity-activity'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-activityDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pages/activity/activityDetail.vue')), 'pages-activity-activityDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-discountTime-discountTime', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pages/discountTime/discountTime.vue')), 'pages-discountTime-discountTime'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-discountTime-discountTimeDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pages/discountTime/discountTimeDetail.vue')), 'pages-discountTime-discountTimeDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-main-showSearch', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pages/main/showSearch.vue')), 'pages-main-showSearch'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-certification-certificationList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/certification/certificationList.vue')), 'pagespacka-certification-certificationList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-certification-addCertification', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/certification/addCertification.vue')), 'pagespacka-certification-addCertification'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-mallCenter-mallCenter', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/mallCenter/mallCenter.vue')), 'pagespacka-mallCenter-mallCenter'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-mallCenter-goodDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/mallCenter/goodDetail.vue')), 'pagespacka-mallCenter-goodDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-mallCenter-goodConfirm', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/mallCenter/goodConfirm.vue')), 'pagespacka-mallCenter-goodConfirm'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-mallCenter-goodRefundOrderList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/mallCenter/goodRefundOrderList.vue')), 'pagespacka-mallCenter-goodRefundOrderList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-mallCenter-goodOrderList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/mallCenter/goodOrderList.vue')), 'pagespacka-mallCenter-goodOrderList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-mallCenter-goodOrderDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/mallCenter/goodOrderDetail.vue')), 'pagespacka-mallCenter-goodOrderDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-personalData-accountSetting', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/personalData/accountSetting.vue')), 'pagespacka-personalData-accountSetting'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-myCoupon-getCouponList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/myCoupon/getCouponList.vue')), 'pagespacka-myCoupon-getCouponList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-myCoupon-couponShowList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/myCoupon/couponShowList.vue')), 'pagespacka-myCoupon-couponShowList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-myCoupon-myCouponDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/myCoupon/myCouponDetail.vue')), 'pagespacka-myCoupon-myCouponDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-myCoupon-myCouponList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/myCoupon/myCouponList.vue')), 'pagespacka-myCoupon-myCouponList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-myCoupon-myCouponListCurrent', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/myCoupon/myCouponListCurrent.vue')), 'pagespacka-myCoupon-myCouponListCurrent'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-favorable-current', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/favorable/current.vue')), 'pagespacka-favorable-current'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-favorable-currentV1', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/favorable/currentV1.vue')), 'pagespacka-favorable-currentV1'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-favorable-currentV2', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/favorable/currentV2.vue')), 'pagespacka-favorable-currentV2'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-newsManage-newsManage', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/newsManage/newsManage.vue')), 'pagespacka-newsManage-newsManage'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-newsManage-newsDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/newsManage/newsDetail.vue')), 'pagespacka-newsManage-newsDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-newsManage-aboutUs', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/newsManage/aboutUs.vue')), 'pagespacka-newsManage-aboutUs'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-newsManage-pagesDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/newsManage/pagesDetail.vue')), 'pagespacka-newsManage-pagesDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-venueManage-rentVenueList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/venueManage/rentVenueList.vue')), 'pagespacka-venueManage-rentVenueList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-venueManage-venueDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/venueManage/venueDetail.vue')), 'pagespacka-venueManage-venueDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-venueManage-venueRent', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/venueManage/venueRent.vue')), 'pagespacka-venueManage-venueRent'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-myOrder-orderConfirm', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/myOrder/orderConfirm.vue')), 'pagespacka-myOrder-orderConfirm'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-myOrder-orderConfirmV1', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/myOrder/orderConfirmV1.vue')), 'pagespacka-myOrder-orderConfirmV1'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-myOrder-orderConfirmV2', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/myOrder/orderConfirmV2.vue')), 'pagespacka-myOrder-orderConfirmV2'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-myOrder-myOrder', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/myOrder/myOrder.vue')), 'pagespacka-myOrder-myOrder'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-myOrder-orderDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/myOrder/orderDetail.vue')), 'pagespacka-myOrder-orderDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-myTicket-ticketDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/myTicket/ticketDetail.vue')), 'pagespacka-myTicket-ticketDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-myTicket-ticketTDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/myTicket/ticketTDetail.vue')), 'pagespacka-myTicket-ticketTDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-myTicket-ticketWalletOver', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/myTicket/ticketWalletOver.vue')), 'pagespacka-myTicket-ticketWalletOver'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-myTicket-sendFriend', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/myTicket/sendFriend.vue')), 'pagespacka-myTicket-sendFriend'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-myOrder-payResult', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/myOrder/payResult.vue')), 'pagespacka-myOrder-payResult'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-myOrder-payResultWx', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/myOrder/payResultWx.vue')), 'pagespacka-myOrder-payResultWx'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-address-address', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/address/address.vue')), 'pagespacka-address-address'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-address-addmore', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/address/addmore.vue')), 'pagespacka-address-addmore'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-sceneActivity-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/sceneActivity/index.vue')), 'pagespacka-sceneActivity-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-personalData-personalData', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/personalData/personalData.vue')), 'pagespacka-personalData-personalData'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-chooseOperasType-chooseOperasType', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/chooseOperasType/chooseOperasType.vue')), 'pagespacka-chooseOperasType-chooseOperasType'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-changePassword-changePassword', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/changePassword/changePassword.vue')), 'pagespacka-changePassword-changePassword'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-memberDegree-memberDegree', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/memberDegree/memberDegree.vue')), 'pagespacka-memberDegree-memberDegree'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-memberDegree-legalRightDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/memberDegree/legalRightDetail.vue')), 'pagespacka-memberDegree-legalRightDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-memberDegree-gropUpDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/memberDegree/gropUpDetail.vue')), 'pagespacka-memberDegree-gropUpDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-chooseSeats-chooseSeats', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/chooseSeats/chooseSeats.vue')), 'pagespacka-chooseSeats-chooseSeats'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-chooseSeats-chooseSeatsV1', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/chooseSeats/chooseSeatsV1.vue')), 'pagespacka-chooseSeats-chooseSeatsV1'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-chooseSeats-chooseSeatsV2', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/chooseSeats/chooseSeatsV2.vue')), 'pagespacka-chooseSeats-chooseSeatsV2'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-myIntegral-myIntegral', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/myIntegral/myIntegral.vue')), 'pagespacka-myIntegral-myIntegral'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-myIntegral-integralRules', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/myIntegral/integralRules.vue')), 'pagespacka-myIntegral-integralRules'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-myIntegral-integralDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/myIntegral/integralDetail.vue')), 'pagespacka-myIntegral-integralDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-valueCard-valueCard', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/valueCard/valueCard.vue')), 'pagespacka-valueCard-valueCard'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-valueCard-valueCardForMe', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/valueCard/valueCardForMe.vue')), 'pagespacka-valueCard-valueCardForMe'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-valueCard-timeCard-timeCardForMe', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/valueCard/timeCard/timeCardForMe.vue')), 'pagespacka-valueCard-timeCard-timeCardForMe'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-valueCard-timeCard-timeCardShowList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/valueCard/timeCard/timeCardShowList.vue')), 'pagespacka-valueCard-timeCard-timeCardShowList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-valueCard-allValueCard-allValueCard', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/valueCard/allValueCard/allValueCard.vue')), 'pagespacka-valueCard-allValueCard-allValueCard'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-valueCard-allValueCard-invalidCard', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/valueCard/allValueCard/invalidCard.vue')), 'pagespacka-valueCard-allValueCard-invalidCard'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-valueCard-cashCard-cashCard', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/valueCard/cashCard/cashCard.vue')), 'pagespacka-valueCard-cashCard-cashCard'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-valueCard-cardMall-cardMall', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/valueCard/cardMall/cardMall.vue')), 'pagespacka-valueCard-cardMall-cardMall'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-valueCard-buyCard-buyCard', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/valueCard/buyCard/buyCard.vue')), 'pagespacka-valueCard-buyCard-buyCard'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-valueCard-buyCard-buyTimeCard', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/valueCard/buyCard/buyTimeCard.vue')), 'pagespacka-valueCard-buyCard-buyTimeCard'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-valueCard-buyCard-success', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/valueCard/buyCard/success.vue')), 'pagespacka-valueCard-buyCard-success'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-valueCard-myStoredValue-myStoredValue', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/valueCard/myStoredValue/myStoredValue.vue')), 'pagespacka-valueCard-myStoredValue-myStoredValue'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-valueCard-balanceDetails-balanceDetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/valueCard/balanceDetails/balanceDetails.vue')), 'pagespacka-valueCard-balanceDetails-balanceDetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-valueCard-valueCardDetails-valueCardDetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/valueCard/valueCardDetails/valueCardDetails.vue')), 'pagespacka-valueCard-valueCardDetails-valueCardDetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-valueCard-valueCardDetails-rechargeDetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/valueCard/valueCardDetails/rechargeDetails.vue')), 'pagespacka-valueCard-valueCardDetails-rechargeDetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-valueCard-timeCard-timeCardDetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/valueCard/timeCard/timeCardDetails.vue')), 'pagespacka-valueCard-timeCard-timeCardDetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-valueCard-timeCard-rechargeDetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/valueCard/timeCard/rechargeDetails.vue')), 'pagespacka-valueCard-timeCard-rechargeDetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-valueCard-timeCard-selectUseTimeCard', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/valueCard/timeCard/selectUseTimeCard.vue')), 'pagespacka-valueCard-timeCard-selectUseTimeCard'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-valueCard-timeCard-selectUseTimeCardV1', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/valueCard/timeCard/selectUseTimeCardV1.vue')), 'pagespacka-valueCard-timeCard-selectUseTimeCardV1'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-valueCard-timeCard-selectUseTimeCardV2', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/valueCard/timeCard/selectUseTimeCardV2.vue')), 'pagespacka-valueCard-timeCard-selectUseTimeCardV2'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-channel-channelShowList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/channel/channelShowList.vue')), 'pagespacka-channel-channelShowList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-channel-my', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/channel/my.vue')), 'pagespacka-channel-my'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-channel-ticketWallet', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/channel/ticketWallet.vue')), 'pagespacka-channel-ticketWallet'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-channel-noActivity', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/channel/noActivity.vue')), 'pagespacka-channel-noActivity'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-selectSeatPage-selectSeatPage', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/selectSeatPage/selectSeatPage.vue')), 'pagespacka-selectSeatPage-selectSeatPage'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-selectSeatPage-selectSeatView', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/selectSeatPage/selectSeatView.vue')), 'pagespacka-selectSeatPage-selectSeatView'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-webView-webView', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/webView/webView.vue')), 'pagespacka-webView-webView'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-webView-middlePage', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/webView/middlePage.vue')), 'pagespacka-webView-middlePage'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-webView-chooseSeat', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/webView/chooseSeat.vue')), 'pagespacka-webView-chooseSeat'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-webView-chooseSeatForTikTok', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/webView/chooseSeatForTikTok.vue')), 'pagespacka-webView-chooseSeatForTikTok'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-webView-chooseSeatForH5', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/webView/chooseSeatForH5.vue')), 'pagespacka-webView-chooseSeatForH5'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagespacka-networkDiagnosis-networkDiagnosis', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/builds/huopiao/HPBuyTicketH5/src/pagespacka/networkDiagnosis/networkDiagnosis.vue')), 'pagespacka-networkDiagnosis-networkDiagnosis'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,

          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationStyle":"default"})
      },
      [
        createElement('pages-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/index',
isQuit:true,
isEntry:true,
  windowTop:44
}
},
{
path: '/pages/home/home',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:0
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"","enablePullDownRefresh":true,"titleNView":false})
      },
      [
        createElement('pages-home-home', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:2,
  name:'pages-home-home',
  isNVue:false,maxWidth:0,
  pagePath:'pages/home/home',
isQuit:true,
isTabBar:true,
tabBarIndex:0,
  windowTop:0
}
},
{
path: '/pages/news/news',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":true,"titleNView":false})
      },
      [
        createElement('pages-news-news', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-news-news',
  isNVue:false,maxWidth:0,
  pagePath:'pages/news/news',
  windowTop:0
}
},
{
path: '/pages/login/login',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"登录"})
      },
      [
        createElement('pages-login-login', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-login',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/login',
  windowTop:44
}
},
{
path: '/pages/login/reg',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"注册"})
      },
      [
        createElement('pages-login-reg', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-reg',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/reg',
  windowTop:44
}
},
{
path: '/pages/login/pwd',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"找回密码"})
      },
      [
        createElement('pages-login-pwd', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-pwd',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/pwd',
  windowTop:44
}
},
{
path: '/pages/ticketWallet/ticketWallet',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:2
        },__uniConfig.globalStyle,{"navigationBarTitleText":"票夹","enablePullDownRefresh":true})
      },
      [
        createElement('pages-ticketWallet-ticketWallet', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:3,
  name:'pages-ticketWallet-ticketWallet',
  isNVue:false,maxWidth:0,
  pagePath:'pages/ticketWallet/ticketWallet',
isQuit:true,
isTabBar:true,
tabBarIndex:2,
  windowTop:44
}
},
{
path: '/pages/my/my',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:3
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的"})
      },
      [
        createElement('pages-my-my', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:4,
  name:'pages-my-my',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/my',
isQuit:true,
isTabBar:true,
tabBarIndex:3,
  windowTop:44
}
},
{
path: '/pages/showDetail/showDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"详情"})
      },
      [
        createElement('pages-showDetail-showDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-showDetail-showDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/showDetail/showDetail',
  windowTop:44
}
},
{
path: '/pages/main/couponList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"领券中心","enablePullDownRefresh":true})
      },
      [
        createElement('pages-main-couponList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-main-couponList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/main/couponList',
  windowTop:44
}
},
{
path: '/pages/activity/activity',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"满减活动","enablePullDownRefresh":true})
      },
      [
        createElement('pages-activity-activity', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-activity',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/activity',
  windowTop:44
}
},
{
path: '/pages/activity/activityDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"活动详情","enablePullDownRefresh":true})
      },
      [
        createElement('pages-activity-activityDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-activityDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/activityDetail',
  windowTop:44
}
},
{
path: '/pages/discountTime/discountTime',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"限时活动","enablePullDownRefresh":true})
      },
      [
        createElement('pages-discountTime-discountTime', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-discountTime-discountTime',
  isNVue:false,maxWidth:0,
  pagePath:'pages/discountTime/discountTime',
  windowTop:44
}
},
{
path: '/pages/discountTime/discountTimeDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"活动详情","enablePullDownRefresh":true})
      },
      [
        createElement('pages-discountTime-discountTimeDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-discountTime-discountTimeDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/discountTime/discountTimeDetail',
  windowTop:44
}
},
{
path: '/pages/main/showSearch',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:1
        },__uniConfig.globalStyle,{"navigationBarTitleText":"演出","enablePullDownRefresh":true})
      },
      [
        createElement('pages-main-showSearch', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:5,
  name:'pages-main-showSearch',
  isNVue:false,maxWidth:0,
  pagePath:'pages/main/showSearch',
isQuit:true,
isTabBar:true,
tabBarIndex:1,
  windowTop:44
}
},
{
path: '/pagespacka/certification/certificationList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"常用观演人","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-certification-certificationList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-certification-certificationList',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/certification/certificationList',
  windowTop:44
}
},
{
path: '/pagespacka/certification/addCertification',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pagespacka-certification-addCertification', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-certification-addCertification',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/certification/addCertification',
  windowTop:44
}
},
{
path: '/pagespacka/mallCenter/mallCenter',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"积分商城","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-mallCenter-mallCenter', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-mallCenter-mallCenter',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/mallCenter/mallCenter',
  windowTop:44
}
},
{
path: '/pagespacka/mallCenter/goodDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品详情"})
      },
      [
        createElement('pagespacka-mallCenter-goodDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-mallCenter-goodDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/mallCenter/goodDetail',
  windowTop:44
}
},
{
path: '/pagespacka/mallCenter/goodConfirm',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"确认订单"})
      },
      [
        createElement('pagespacka-mallCenter-goodConfirm', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-mallCenter-goodConfirm',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/mallCenter/goodConfirm',
  windowTop:44
}
},
{
path: '/pagespacka/mallCenter/goodRefundOrderList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"退货"})
      },
      [
        createElement('pagespacka-mallCenter-goodRefundOrderList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-mallCenter-goodRefundOrderList',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/mallCenter/goodRefundOrderList',
  windowTop:44
}
},
{
path: '/pagespacka/mallCenter/goodOrderList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单列表","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-mallCenter-goodOrderList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-mallCenter-goodOrderList',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/mallCenter/goodOrderList',
  windowTop:44
}
},
{
path: '/pagespacka/mallCenter/goodOrderDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单详情"})
      },
      [
        createElement('pagespacka-mallCenter-goodOrderDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-mallCenter-goodOrderDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/mallCenter/goodOrderDetail',
  windowTop:44
}
},
{
path: '/pagespacka/personalData/accountSetting',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"设置"})
      },
      [
        createElement('pagespacka-personalData-accountSetting', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-personalData-accountSetting',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/personalData/accountSetting',
  windowTop:44
}
},
{
path: '/pagespacka/myCoupon/getCouponList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"领券"})
      },
      [
        createElement('pagespacka-myCoupon-getCouponList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-myCoupon-getCouponList',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/myCoupon/getCouponList',
  windowTop:44
}
},
{
path: '/pagespacka/myCoupon/couponShowList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"适用演出"})
      },
      [
        createElement('pagespacka-myCoupon-couponShowList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-myCoupon-couponShowList',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/myCoupon/couponShowList',
  windowTop:44
}
},
{
path: '/pagespacka/myCoupon/myCouponDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的优惠券"})
      },
      [
        createElement('pagespacka-myCoupon-myCouponDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-myCoupon-myCouponDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/myCoupon/myCouponDetail',
  windowTop:44
}
},
{
path: '/pagespacka/myCoupon/myCouponList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的优惠券","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-myCoupon-myCouponList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-myCoupon-myCouponList',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/myCoupon/myCouponList',
  windowTop:44
}
},
{
path: '/pagespacka/myCoupon/myCouponListCurrent',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的优惠券"})
      },
      [
        createElement('pagespacka-myCoupon-myCouponListCurrent', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-myCoupon-myCouponListCurrent',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/myCoupon/myCouponListCurrent',
  windowTop:44
}
},
{
path: '/pagespacka/favorable/current',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"选择优惠券","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-favorable-current', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-favorable-current',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/favorable/current',
  windowTop:44
}
},
{
path: '/pagespacka/favorable/currentV1',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"选择优惠券","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-favorable-currentV1', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-favorable-currentV1',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/favorable/currentV1',
  windowTop:44
}
},
{
path: '/pagespacka/favorable/currentV2',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"选择优惠券","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-favorable-currentV2', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-favorable-currentV2',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/favorable/currentV2',
  windowTop:44
}
},
{
path: '/pagespacka/newsManage/newsManage',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"新闻资讯","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-newsManage-newsManage', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-newsManage-newsManage',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/newsManage/newsManage',
  windowTop:44
}
},
{
path: '/pagespacka/newsManage/newsDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"新闻详情"})
      },
      [
        createElement('pagespacka-newsManage-newsDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-newsManage-newsDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/newsManage/newsDetail',
  windowTop:44
}
},
{
path: '/pagespacka/newsManage/aboutUs',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"关于我们"})
      },
      [
        createElement('pagespacka-newsManage-aboutUs', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-newsManage-aboutUs',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/newsManage/aboutUs',
  windowTop:44
}
},
{
path: '/pagespacka/newsManage/pagesDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"文章详情"})
      },
      [
        createElement('pagespacka-newsManage-pagesDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-newsManage-pagesDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/newsManage/pagesDetail',
  windowTop:44
}
},
{
path: '/pagespacka/venueManage/rentVenueList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"场馆租赁","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-venueManage-rentVenueList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-venueManage-rentVenueList',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/venueManage/rentVenueList',
  windowTop:44
}
},
{
path: '/pagespacka/venueManage/venueDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"场馆详情"})
      },
      [
        createElement('pagespacka-venueManage-venueDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-venueManage-venueDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/venueManage/venueDetail',
  windowTop:44
}
},
{
path: '/pagespacka/venueManage/venueRent',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"预约"})
      },
      [
        createElement('pagespacka-venueManage-venueRent', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-venueManage-venueRent',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/venueManage/venueRent',
  windowTop:44
}
},
{
path: '/pagespacka/myOrder/orderConfirm',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"确认订单"})
      },
      [
        createElement('pagespacka-myOrder-orderConfirm', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-myOrder-orderConfirm',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/myOrder/orderConfirm',
  windowTop:44
}
},
{
path: '/pagespacka/myOrder/orderConfirmV1',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"确认订单"})
      },
      [
        createElement('pagespacka-myOrder-orderConfirmV1', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-myOrder-orderConfirmV1',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/myOrder/orderConfirmV1',
  windowTop:44
}
},
{
path: '/pagespacka/myOrder/orderConfirmV2',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"确认订单"})
      },
      [
        createElement('pagespacka-myOrder-orderConfirmV2', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-myOrder-orderConfirmV2',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/myOrder/orderConfirmV2',
  windowTop:44
}
},
{
path: '/pagespacka/myOrder/myOrder',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的订单"})
      },
      [
        createElement('pagespacka-myOrder-myOrder', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-myOrder-myOrder',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/myOrder/myOrder',
  windowTop:44
}
},
{
path: '/pagespacka/myOrder/orderDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单详情"})
      },
      [
        createElement('pagespacka-myOrder-orderDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-myOrder-orderDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/myOrder/orderDetail',
  windowTop:44
}
},
{
path: '/pagespacka/myTicket/ticketDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"票详情"})
      },
      [
        createElement('pagespacka-myTicket-ticketDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-myTicket-ticketDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/myTicket/ticketDetail',
  windowTop:44
}
},
{
path: '/pagespacka/myTicket/ticketTDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"票详情"})
      },
      [
        createElement('pagespacka-myTicket-ticketTDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-myTicket-ticketTDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/myTicket/ticketTDetail',
  windowTop:44
}
},
{
path: '/pagespacka/myTicket/ticketWalletOver',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"历史票"})
      },
      [
        createElement('pagespacka-myTicket-ticketWalletOver', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-myTicket-ticketWalletOver',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/myTicket/ticketWalletOver',
  windowTop:44
}
},
{
path: '/pagespacka/myTicket/sendFriend',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"转赠票给好友"})
      },
      [
        createElement('pagespacka-myTicket-sendFriend', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-myTicket-sendFriend',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/myTicket/sendFriend',
  windowTop:44
}
},
{
path: '/pagespacka/myOrder/payResult',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"支付成功","titleNView":false})
      },
      [
        createElement('pagespacka-myOrder-payResult', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-myOrder-payResult',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/myOrder/payResult',
  windowTop:0
}
},
{
path: '/pagespacka/myOrder/payResultWx',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"支付"})
      },
      [
        createElement('pagespacka-myOrder-payResultWx', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-myOrder-payResultWx',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/myOrder/payResultWx',
  windowTop:44
}
},
{
path: '/pagespacka/address/address',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收货地址","disableScroll":true})
      },
      [
        createElement('pagespacka-address-address', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-address-address',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/address/address',
  windowTop:44
}
},
{
path: '/pagespacka/address/addmore',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"新增收货地址"})
      },
      [
        createElement('pagespacka-address-addmore', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-address-addmore',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/address/addmore',
  windowTop:44
}
},
{
path: '/pagespacka/sceneActivity/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"场景活动"})
      },
      [
        createElement('pagespacka-sceneActivity-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-sceneActivity-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/sceneActivity/index',
  windowTop:44
}
},
{
path: '/pagespacka/personalData/personalData',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"个人资料"})
      },
      [
        createElement('pagespacka-personalData-personalData', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-personalData-personalData',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/personalData/personalData',
  windowTop:44
}
},
{
path: '/pagespacka/chooseOperasType/chooseOperasType',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"个人资料"})
      },
      [
        createElement('pagespacka-chooseOperasType-chooseOperasType', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-chooseOperasType-chooseOperasType',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/chooseOperasType/chooseOperasType',
  windowTop:44
}
},
{
path: '/pagespacka/changePassword/changePassword',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"修改密码"})
      },
      [
        createElement('pagespacka-changePassword-changePassword', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-changePassword-changePassword',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/changePassword/changePassword',
  windowTop:44
}
},
{
path: '/pagespacka/memberDegree/memberDegree',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"会员等级","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-memberDegree-memberDegree', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-memberDegree-memberDegree',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/memberDegree/memberDegree',
  windowTop:44
}
},
{
path: '/pagespacka/memberDegree/legalRightDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"权益详情","enablePullDownRefresh":false})
      },
      [
        createElement('pagespacka-memberDegree-legalRightDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-memberDegree-legalRightDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/memberDegree/legalRightDetail',
  windowTop:44
}
},
{
path: '/pagespacka/memberDegree/gropUpDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"成长值明细","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-memberDegree-gropUpDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-memberDegree-gropUpDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/memberDegree/gropUpDetail',
  windowTop:44
}
},
{
path: '/pagespacka/chooseSeats/chooseSeats',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"选座","enablePullDownRefresh":false,"disableScroll":true})
      },
      [
        createElement('pagespacka-chooseSeats-chooseSeats', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-chooseSeats-chooseSeats',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/chooseSeats/chooseSeats',
  windowTop:44
}
},
{
path: '/pagespacka/chooseSeats/chooseSeatsV1',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"选座","enablePullDownRefresh":false,"disableScroll":true})
      },
      [
        createElement('pagespacka-chooseSeats-chooseSeatsV1', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-chooseSeats-chooseSeatsV1',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/chooseSeats/chooseSeatsV1',
  windowTop:44
}
},
{
path: '/pagespacka/chooseSeats/chooseSeatsV2',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"选座","enablePullDownRefresh":false,"disableScroll":true})
      },
      [
        createElement('pagespacka-chooseSeats-chooseSeatsV2', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-chooseSeats-chooseSeatsV2',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/chooseSeats/chooseSeatsV2',
  windowTop:44
}
},
{
path: '/pagespacka/myIntegral/myIntegral',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的积分","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-myIntegral-myIntegral', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-myIntegral-myIntegral',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/myIntegral/myIntegral',
  windowTop:44
}
},
{
path: '/pagespacka/myIntegral/integralRules',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"积分规则","enablePullDownRefresh":false})
      },
      [
        createElement('pagespacka-myIntegral-integralRules', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-myIntegral-integralRules',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/myIntegral/integralRules',
  windowTop:44
}
},
{
path: '/pagespacka/myIntegral/integralDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"积分明细","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-myIntegral-integralDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-myIntegral-integralDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/myIntegral/integralDetail',
  windowTop:44
}
},
{
path: '/pagespacka/valueCard/valueCard',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"礼品卡","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-valueCard-valueCard', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-valueCard-valueCard',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/valueCard/valueCard',
  windowTop:44
}
},
{
path: '/pagespacka/valueCard/valueCardForMe',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的礼品卡","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-valueCard-valueCardForMe', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-valueCard-valueCardForMe',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/valueCard/valueCardForMe',
  windowTop:44
}
},
{
path: '/pagespacka/valueCard/timeCard/timeCardForMe',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的次卡","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-valueCard-timeCard-timeCardForMe', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-valueCard-timeCard-timeCardForMe',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/valueCard/timeCard/timeCardForMe',
  windowTop:44
}
},
{
path: '/pagespacka/valueCard/timeCard/timeCardShowList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"次卡演出","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-valueCard-timeCard-timeCardShowList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-valueCard-timeCard-timeCardShowList',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/valueCard/timeCard/timeCardShowList',
  windowTop:44
}
},
{
path: '/pagespacka/valueCard/allValueCard/allValueCard',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"全部礼品卡","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-valueCard-allValueCard-allValueCard', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-valueCard-allValueCard-allValueCard',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/valueCard/allValueCard/allValueCard',
  windowTop:44
}
},
{
path: '/pagespacka/valueCard/allValueCard/invalidCard',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"已失效礼品卡","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-valueCard-allValueCard-invalidCard', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-valueCard-allValueCard-invalidCard',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/valueCard/allValueCard/invalidCard',
  windowTop:44
}
},
{
path: '/pagespacka/valueCard/cashCard/cashCard',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"兑换绑卡","enablePullDownRefresh":false})
      },
      [
        createElement('pagespacka-valueCard-cashCard-cashCard', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-valueCard-cashCard-cashCard',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/valueCard/cashCard/cashCard',
  windowTop:44
}
},
{
path: '/pagespacka/valueCard/cardMall/cardMall',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"购卡中心","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-valueCard-cardMall-cardMall', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-valueCard-cardMall-cardMall',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/valueCard/cardMall/cardMall',
  windowTop:44
}
},
{
path: '/pagespacka/valueCard/buyCard/buyCard',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"礼品卡","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-valueCard-buyCard-buyCard', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-valueCard-buyCard-buyCard',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/valueCard/buyCard/buyCard',
  windowTop:44
}
},
{
path: '/pagespacka/valueCard/buyCard/buyTimeCard',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"次卡","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-valueCard-buyCard-buyTimeCard', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-valueCard-buyCard-buyTimeCard',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/valueCard/buyCard/buyTimeCard',
  windowTop:44
}
},
{
path: '/pagespacka/valueCard/buyCard/success',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"购卡成功","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-valueCard-buyCard-success', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-valueCard-buyCard-success',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/valueCard/buyCard/success',
  windowTop:44
}
},
{
path: '/pagespacka/valueCard/myStoredValue/myStoredValue',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的储值","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-valueCard-myStoredValue-myStoredValue', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-valueCard-myStoredValue-myStoredValue',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/valueCard/myStoredValue/myStoredValue',
  windowTop:44
}
},
{
path: '/pagespacka/valueCard/balanceDetails/balanceDetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"余额明细","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-valueCard-balanceDetails-balanceDetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-valueCard-balanceDetails-balanceDetails',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/valueCard/balanceDetails/balanceDetails',
  windowTop:44
}
},
{
path: '/pagespacka/valueCard/valueCardDetails/valueCardDetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"礼品卡","enablePullDownRefresh":false})
      },
      [
        createElement('pagespacka-valueCard-valueCardDetails-valueCardDetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-valueCard-valueCardDetails-valueCardDetails',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/valueCard/valueCardDetails/valueCardDetails',
  windowTop:44
}
},
{
path: '/pagespacka/valueCard/valueCardDetails/rechargeDetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"礼品卡明细","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-valueCard-valueCardDetails-rechargeDetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-valueCard-valueCardDetails-rechargeDetails',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/valueCard/valueCardDetails/rechargeDetails',
  windowTop:44
}
},
{
path: '/pagespacka/valueCard/timeCard/timeCardDetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的次卡","enablePullDownRefresh":false})
      },
      [
        createElement('pagespacka-valueCard-timeCard-timeCardDetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-valueCard-timeCard-timeCardDetails',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/valueCard/timeCard/timeCardDetails',
  windowTop:44
}
},
{
path: '/pagespacka/valueCard/timeCard/rechargeDetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"次卡明细","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-valueCard-timeCard-rechargeDetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-valueCard-timeCard-rechargeDetails',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/valueCard/timeCard/rechargeDetails',
  windowTop:44
}
},
{
path: '/pagespacka/valueCard/timeCard/selectUseTimeCard',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的次卡","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-valueCard-timeCard-selectUseTimeCard', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-valueCard-timeCard-selectUseTimeCard',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/valueCard/timeCard/selectUseTimeCard',
  windowTop:44
}
},
{
path: '/pagespacka/valueCard/timeCard/selectUseTimeCardV1',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的次卡","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-valueCard-timeCard-selectUseTimeCardV1', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-valueCard-timeCard-selectUseTimeCardV1',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/valueCard/timeCard/selectUseTimeCardV1',
  windowTop:44
}
},
{
path: '/pagespacka/valueCard/timeCard/selectUseTimeCardV2',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的次卡","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-valueCard-timeCard-selectUseTimeCardV2', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-valueCard-timeCard-selectUseTimeCardV2',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/valueCard/timeCard/selectUseTimeCardV2',
  windowTop:44
}
},
{
path: '/pagespacka/channel/channelShowList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"更多演出","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-channel-channelShowList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-channel-channelShowList',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/channel/channelShowList',
  windowTop:44
}
},
{
path: '/pagespacka/channel/my',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","titleNView":false})
      },
      [
        createElement('pagespacka-channel-my', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-channel-my',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/channel/my',
  windowTop:0
}
},
{
path: '/pagespacka/channel/ticketWallet',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"票夹","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-channel-ticketWallet', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-channel-ticketWallet',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/channel/ticketWallet',
  windowTop:44
}
},
{
path: '/pagespacka/channel/noActivity',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"活动不存在","enablePullDownRefresh":true})
      },
      [
        createElement('pagespacka-channel-noActivity', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-channel-noActivity',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/channel/noActivity',
  windowTop:44
}
},
{
path: '/pagespacka/selectSeatPage/selectSeatPage',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationStyle":"default","disableScroll":true})
      },
      [
        createElement('pagespacka-selectSeatPage-selectSeatPage', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-selectSeatPage-selectSeatPage',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/selectSeatPage/selectSeatPage',
  windowTop:44
}
},
{
path: '/pagespacka/selectSeatPage/selectSeatView',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"选择座位","disableScroll":true})
      },
      [
        createElement('pagespacka-selectSeatPage-selectSeatView', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-selectSeatPage-selectSeatView',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/selectSeatPage/selectSeatView',
  windowTop:44
}
},
{
path: '/pagespacka/webView/webView',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"选座","disableScroll":true})
      },
      [
        createElement('pagespacka-webView-webView', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-webView-webView',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/webView/webView',
  windowTop:44
}
},
{
path: '/pagespacka/webView/middlePage',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","disableScroll":true})
      },
      [
        createElement('pagespacka-webView-middlePage', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-webView-middlePage',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/webView/middlePage',
  windowTop:44
}
},
{
path: '/pagespacka/webView/chooseSeat',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","disableScroll":true})
      },
      [
        createElement('pagespacka-webView-chooseSeat', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-webView-chooseSeat',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/webView/chooseSeat',
  windowTop:0
}
},
{
path: '/pagespacka/webView/chooseSeatForTikTok',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","disableScroll":true})
      },
      [
        createElement('pagespacka-webView-chooseSeatForTikTok', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-webView-chooseSeatForTikTok',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/webView/chooseSeatForTikTok',
  windowTop:0
}
},
{
path: '/pagespacka/webView/chooseSeatForH5',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","disableScroll":true})
      },
      [
        createElement('pagespacka-webView-chooseSeatForH5', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-webView-chooseSeatForH5',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/webView/chooseSeatForH5',
  windowTop:0
}
},
{
path: '/pagespacka/networkDiagnosis/networkDiagnosis',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"网络诊断"})
      },
      [
        createElement('pagespacka-networkDiagnosis-networkDiagnosis', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagespacka-networkDiagnosis-networkDiagnosis',
  isNVue:false,maxWidth:0,
  pagePath:'pagespacka/networkDiagnosis/networkDiagnosis',
  windowTop:44
}
},
{
path: '/preview-image',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-preview-image', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'preview-image',
  pagePath:'/preview-image'
}
}
    ,
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
